import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";

const ShopDetail = () => {

    const sliderForRef = useRef(null);
    const sliderNavRef = useRef(null);
    const [qty, setQty] = useState(1);

    const settingsFor = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: sliderNavRef.current
    };

    const settingsNav = {
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: sliderForRef.current,
        dots: false,
        focusOnSelect: true
    };

    const increase = () => {
        setQty(qty + 1);
    };

    const decrease = () => {
        if (qty > 1) {
            setQty(qty - 1);
        }
    };

    const handleChange = (e) => {
        const value = Number(e.target.value);
        if (value >= 1) {
            setQty(value);
        }
    };

    return (
        <>
            <section className="main_slider">
                <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <div className="inr_bnr_bg">
                                <img src="images/inrbnr.png" className="img-fluid" alt="..." />
                            </div>
                            <div className="carousel-caption">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className=" col-lg-6 col-md-8 col-sm-4 align-self-center">
                                            <div className="banner_text wow animate__animated animate__slideInLeft" data-wow-delay="0.3s" data-wow-duration="1s">
                                                <h1>Shop Detail</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="proddet all-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 ">
                            <div className="slider-for">
                                <Slider {...settingsFor} ref={sliderForRef}>
                                    <div>
                                        <img src="images/seller-1.jpg" className="img-fluid he1" alt="img" />
                                    </div>
                                    <div>
                                        <img src="images/seller-2.jpg" className="img-fluid he1" alt="img" />
                                    </div>
                                    <div>
                                        <img src="images/seller-3.jpg" className="img-fluid he1" alt="img" />
                                    </div>
                                    <div>
                                        <img src="images/seller-4.jpg" className="img-fluid he1" alt="img" />
                                    </div>
                                </Slider>
                            </div>
                            <div className="row pt-4">
                                <div className="col-md-12">
                                    <div className="slider-nav">
                                        <Slider {...settingsNav} ref={sliderNavRef}>
                                            <div>
                                                <img src="images/seller-1.jpg" className="img-fluid he2" alt="img" />
                                            </div>
                                            <div>
                                                <img src="images/seller-2.jpg" className="img-fluid he2" alt="img" />
                                            </div>
                                            <div>
                                                <img src="images/seller-3.jpg" className="img-fluid he2" alt="img" />
                                            </div>
                                            <div>
                                                <img src="images/seller-4.jpg" className="img-fluid he2" alt="img" />
                                            </div>
                                        </Slider>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                            <div className="product-detail-box">
                                <h2>Products Name Here </h2>
                                <div className="reviews">
                                    <span className="stars">
                                        <i className="fa-solid fa-star" />
                                        <i className="fa-solid fa-star" />
                                        <i className="fa-solid fa-star" />
                                        <i className="fa-solid fa-star" />
                                        <i className="fa-solid fa-star" />
                                    </span>
                                    <span className="review-count">4.5k Reviews</span> |
                                    <Link to="#" className="write-review">Write your Review</Link>
                                </div>
                                <h3>$90.00</h3>
                                <h4>
                                    Consec Adipisicing Elit Dummy Here</h4>
                                <p className="description">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                                    labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
                                    laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in
                                    voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                                    cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                                </p>
                                <h5>Availability: 45 in stock</h5>
                                <div className="quantity-section">
                                    <div className="cart-page-quantity">
                                        <span className="minus" onClick={decrease}>
                                            <i className="fa-solid fa-minus" />
                                        </span>
                                        <input type="number" value={qty} onChange={handleChange} />
                                        <span className="plus" onClick={increase}>
                                            <i className="fa-solid fa-plus" />
                                        </span>
                                    </div>
                                    <Link to="/cart" className="theme_btn1">
                                        <div className="theme-btn-inner1">
                                            <div className="btn-text1">add to cart</div>
                                            <div className="btn-img1"><img src="images/btn-img2.png" alt />
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="product-meta">
                                    <div>
                                        <p>SKU: 123456Abc</p>
                                        <p>Category: Here</p>
                                    </div>
                                    <div>
                                        <p>Tags: dummy text</p>
                                        <div className="share">
                                            <p>Share: </p>
                                            <Link to="#"><i className="fab fa-facebook-f" /></Link>
                                            <Link to="#"><i className="fab fa-instagram" /></Link>
                                            <Link to="#"><i className="fab fa-linkedin-in" /></Link>
                                            <Link to="#"><i className="fas fa-times" /></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="description pb-5 wow animate__animated animate__fadeInDown" data-wow-duration="2s">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <ul className="nav nav-tabs" id="myTab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link active" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">
                                        Description
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="settings-tab" data-bs-toggle="tab" data-bs-target="#settings" type="button" role="tab" aria-controls="settings" aria-selected="false">
                                        Additional information
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="messages-tab" data-bs-toggle="tab" data-bs-target="#messages" type="button" role="tab" aria-controls="messages" aria-selected="false">
                                        Reviews (4)
                                    </button>
                                </li>
                            </ul>
                            <div className="tab-content">
                                <div className="tab-pane active" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                    <p>
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum
                                        has been the industry's standard dummy text ever since the 1500s, when an unknown
                                        printer took a galley of type and scrambled it to make a type specimen book. It has
                                        survived not only five centuries, but also the leap into electronic typesetting,
                                        remaining essentially unchanged. It was popularised in the 1960s with the release of
                                        Letraset sheets containing Lorem Ipsum passages, and more recently with desktop
                                        publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                                    </p>
                                    <p>
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum
                                        has been the industry's standard dummy text ever since the 1500s, when an unknown
                                        printer took a galley of type and scrambled it to make a type specimen book. It has
                                        survived not only five centuries, but also the leap into electronic typesetting,
                                        remaining essentially unchanged. It was popularised in the 1960s with the release of
                                        Letraset sheets containing.
                                    </p>
                                    <div className="tbs_flx_main">
                                        <div className="tbs_flx_img">
                                            <img src="images/tabs_chk.png" alt />
                                        </div>
                                        <div className="tbs_flx_text">
                                            <span>dolor sit amet </span>
                                        </div>
                                    </div>
                                    <div className="tbs_flx_main">
                                        <div className="tbs_flx_img">
                                            <img src="images/tabs_chk.png" alt />
                                        </div>
                                        <div className="tbs_flx_text">
                                            <span>dolor sit amet </span>
                                        </div>
                                    </div>
                                    <div className="tbs_flx_main">
                                        <div className="tbs_flx_img">
                                            <img src="images/tabs_chk.png" alt />
                                        </div>
                                        <div className="tbs_flx_text">
                                            <span>dolor sit amet </span>
                                        </div>
                                    </div>
                                    <div className="tbs_flx_main">
                                        <div className="tbs_flx_img">
                                            <img src="images/tabs_chk.png" alt />
                                        </div>
                                        <div className="tbs_flx_text">
                                            <span>dolor sit amet </span>
                                        </div>
                                    </div>
                                    <p>
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum
                                        has been the industry's standard dummy text ever since the 1500s, when an unknown
                                        printer took a galley of type and scrambled it to make a type specimen book. It has
                                        survived not only five centuries, but also the leap into electronic typesetting,
                                        remaining essentially unchanged. It was popularised in the 1960s with the release of
                                        Letraset sheets containing Lorem Ipsum passages, and more recently with desktop
                                        publishing software like Aldus PageMaker including versions of Lorem Ipsum
                                    </p>
                                </div>
                                <div className="tab-pane" id="settings" role="tabpanel" aria-labelledby="settings-tab">
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                                        do eiusmod tempor incididunt ut labore elt dolore magna aliqua
                                        uliat enim ad minim veniam, quis nostrud exercitation ullamco
                                        laboris nisi ut aliquip ex ea commodo consequat duis aute
                                        irure dolor in reprehenderit in voluptate velit esse cillum
                                        dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                                        cupidatat non proident suint in culpa qui officia deserunt
                                        mollit anim id est laborum. This is Photoshop's version of
                                        Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet.
                                        Aenean sollicitudin, lorem quis bibendum auctor, nisi elit
                                        consequat ipsum, nec sagittis sem nibh id elit. Duis sed odio
                                        sit amet nibh vulputate cursus a sit amet mauris. Morbi
                                        accumsan ipsum velit. Nam nec tellus a odio tincidunt auctor a
                                        ornare odio. Sed non mauris vitae erat consequat auctor eu
                                        inist eliate. Class aptent taciti sociosqu ad litora torquent
                                        per conubia nostra, per inceptos himenaeos. Mauris in erat
                                        justo. Nullam ac urna eu felis dapibus condimentum sit amet a
                                        augue. Sed non neque elit. Sed ut imperdiet nisi. Proin
                                        condimentum fermentum nunc. Etiam pharetra, erat sed fermentum
                                        feugiat, velit mauris egestas quam, ut aliquam massa nisl quis
                                        neque. Suspendisse in orci enim.
                                    </p>
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                                        do eiusmod tempor incididunt ut labore elt dolore magna aliqua
                                        uliat enim ad minim veniam, quis nostrud exercitation ullamco
                                        laboris nisi ut aliquip ex ea commodo consequat duis aute
                                        irure dolor in reprehenderit in voluptate velit esse .
                                    </p>
                                </div>
                                <div className="tab-pane" id="messages" role="tabpanel" aria-labelledby="messages-tab">
                                    <form action="#">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <input type="text" placeholder="First Name" />
                                            </div>
                                            <div className="col-md-6">
                                                <input type="text" placeholder="Your Email" />
                                            </div>
                                            <div className="col-md-6">
                                                {/* <div class="product-ratting">
                              <div class="prdtc-rvw">
                                  <ul>
                                      <li><i class="fal fa-star"></i></li>
                                      <li><i class="fal fa-star"></i></li>
                                      <li><i class="fal fa-star"></i></li>
                                      <li><i class="fal fa-star"></i></li>
                                      <li><i class="fal fa-star"></i></li>
                                  </ul>
                              </div>
                              </div> */}
                                            </div>
                                            <div className="col-md-12">
                                                <textarea placeholder="Write Your Review" rows={10} defaultValue={""} />
                                                <div className="rev-btn">
                                                </div>
                                            </div>
                                            <div className="review-btn">
                                                <button type="submit" className="theme_btn1">
                                                    <div className="theme-btn-inner1">
                                                        <div className="btn-text1">Submit NOw</div>
                                                        <div className="btn-img1"><img src="images/btn-img2.png" alt />
                                                        </div>
                                                    </div>
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>

    )
}

export default ShopDetail